import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";
import * as qs from "qs";

export const JobBoardService = {
    postjobboards,
  getJobBoards,
  updateJobBoards,
  deleteJobBoard,
  uploadJobBoardImage,
  getJobBoardPost,
 
}

function postjobboards(createObj) {
    return axiosInterceptors
      .post(ENV.job_boards,createObj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  
  
  function getJobBoards(search,
    itemsPerPage,
    currentPage,
    sortBy,
    sortOrder) {
      
      let getJobBoardsurl =
      ENV.job_boards;
      return axiosInterceptors
      .get(getJobBoardsurl,{
        params: {
          search: search,
          ps: itemsPerPage,
          pn: currentPage,
          sortBy: sortBy,
          sortOrder: sortOrder,
  },
  paramsSerializer: (params) => {
    var qps = qs.stringify(params, { arrayFormat: "repeat" });
    return qps;
  },
  })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });  
  }
  
  function getJobBoardPost() {
    return axiosInterceptors
     .get( ENV.job_boards)
     .then((response) => {
      return response;
     })
     .catch((error) => {
      return error;
     });
   }
  
  function updateJobBoards(reqobj,jobBoard_id) {
  
    return axiosInterceptors
      .put(ENV.job_boards + jobBoard_id,reqobj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  function deleteJobBoard(jobBoard_id) {
    return axiosInterceptors
      .delete(ENV.job_boards+jobBoard_id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }
  
  
  export function uploadJobBoardImage(file) {
    return axiosInterceptors
    .post(ENV.job_boards + "image" + "/upload",file)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });  
  }

  export function addjobBoardContactService(Createobj) {
    const jobboardId = window.localStorage.getItem("jobboardId");
    let addContacturl = ENV.job_boards + jobboardId + "/contact";
    return axiosInterceptors
    .post(addContacturl,Createobj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }

  export function getJobBoardContactsService(job_board_id,search,itemsPerPage,currentPage, sortBy,
    sortOrder) {
    let getContactsurl = ENV.job_boards + job_board_id + "/contacts";
    return axiosInterceptors
    .get(getContactsurl,{
    params:{
      search:search,
      ps: itemsPerPage,
      pn:currentPage,
      sortBy: sortBy,
        sortOrder: sortOrder,
    }
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }

export function updatejobBoardContactService(updateObj,job_board_id,jobboard_contact_id) {


    let updateContacturl = ENV.job_boards + job_board_id + "/contacts/"+jobboard_contact_id;
      return axiosInterceptors
      .put(updateContacturl,updateObj)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
    }

export function deleteJobBoardContactservice(jobboard_contact_id,job_board_id) {
    let deleteContacturl = ENV.job_boards + job_board_id + "/contacts/"+jobboard_contact_id;
    return axiosInterceptors
    .delete(deleteContacturl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }